import { render, staticRenderFns } from "./StepProgressBar.vue?vue&type=template&id=496e4cc8&scoped=true&"
import script from "./StepProgressBar.vue?vue&type=script&lang=js&"
export * from "./StepProgressBar.vue?vue&type=script&lang=js&"
import style0 from "./StepProgressBar.vue?vue&type=style&index=0&id=496e4cc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496e4cc8",
  null
  
)

export default component.exports